import { Box, Typography } from "@mui/material";
import { ListAssignedTalent } from "./orderAPI";
import { LightTooltip } from "../../common/components/styled/tooltips/StyledTooltips";
import { Fragment } from "react/jsx-runtime";
import { getName } from "../../common/helpers/common";
import { TalentLinkLight } from "../../common/components/functional/links/TalentLinkLight";

export const getAssignedTalents = (
  talents: ListAssignedTalent[],
  label: string,
) => {
  if (talents.length > 2) {
    const title = talents.map((talent) => (
      <Typography fontSize={14} key={talent.id}>
        <TalentLinkLight
          id={talent.id}
          label={getName(talent, "firstNameFirst")}
        />
      </Typography>
    ));
    return (
      <LightTooltip
        disableFocusListener
        disableTouchListener
        title={title}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Typography fontSize={14} color={"primary.light"}>
          {label}
        </Typography>
      </LightTooltip>
    );
  } else {
    return (
      <Box display="flex" flexDirection="column" margin="-10px 0">
        {talents.map((talent) => (
          <Fragment key={talent.id}>
            <TalentLinkLight
              id={talent.id}
              label={getName(talent, "firstNameFirst")}
            />
          </Fragment>
        ))}
      </Box>
    );
  }
};
